import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  skeletonContainer: {
    borderRadius: 0,
  },
  skeleton: {
    marginBottom: 8,
    height: 32,
    width: '80%',
  },
  skeletonLast: {
    marginBottom: 16,
    height: 32,
    width: '80%',
  },
  cardContent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
});

export default useStyles;
